import { Action, createSlice } from "@reduxjs/toolkit";

import { ILoaderStatus } from "./types";

const initialState: ILoaderStatus = {
  isLoading: false
};

export const loaderSlice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    handleLoading: (state, action) => {
      state.isLoading = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        (action: Action) => action.type.startsWith("loader") && action.type.endsWith("/pending"),
        (state) => {
          state.isLoading = true;
        }
      )
      .addMatcher(
        (action: Action) => action.type.startsWith("loader") && action.type.endsWith("/fulfilled"),
        (state) => {
          state.isLoading = false;
        }
      )
      .addMatcher(
        (action: Action) => action.type.startsWith("loader") && action.type.endsWith("/rejected"),
        (state) => {
          state.isLoading = false;
        }
      );
  }
});

export const { handleLoading } = loaderSlice.actions;

export default loaderSlice.reducer;
